var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"minidiv p-1 m-2"},[_c('div',{staticClass:"flex-parent text-center p-1"},_vm._l((_vm.fields),function(field,index){return _c('div',{key:index,staticClass:"flex-child"},[_vm._t(field,function(){return [_c('div',{staticClass:"p-2 text-left result-col"},[_vm._v(_vm._s(_vm.data[field]))])]},{"data":_vm.data})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }